import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getOrder } from "./api";
import ShopNavBar from "./components/ShopNavBar";
import Spinner from "./components/Spinner";
import EmptyState from "./components/EmptyState";

const STATUS_COLORS = {
  PAID: "text-green-700 bg-green-50",
  CONFIRMED: "text-green-700 bg-green-50",
  PENDING: "text-amber-700 bg-amber-50",
};

export default function OrderDetail() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getOrder(orderId)
      .then((res) => setOrder(res.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [orderId]);

  return (
    <div className="min-h-screen pb-10">
      <ShopNavBar title="Order Details" showProfile={false} />

      <div className="px-4 pt-4">
        {loading && <Spinner label="Loading order…" />}

        {!loading && error && (
          <EmptyState title="Couldn't load this order" subtitle={error} />
        )}

        {!loading && order && (
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-lg bg-gray-100 overflow-hidden shrink-0">
                {order.shopFront?.logoUrl && (
                  <img
                    src={order.shopFront.logoUrl}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
              <div className="min-w-0">
                <p className="font-semibold otaDark truncate">
                  {order.shopFront?.name}
                </p>
                <p className="text-xs otaLight">
                  {new Date(order.createdAt).toLocaleString()}
                </p>
              </div>
              <span
                className={`ml-auto shrink-0 text-[11px] font-semibold px-2 py-1 rounded-full ${
                  STATUS_COLORS[order.paymentStatus] ||
                  "text-gray-600 bg-gray-100"
                }`}
              >
                {order.status}
              </span>
            </div>

            <div className="rounded-xl border border-gray-100 cardShadow p-4 flex flex-col gap-2">
              {order.items?.map((item) => (
                <div
                  key={item.id}
                  className="flex justify-between text-sm otaDark"
                >
                  <span>Qty {item.quantity}</span>
                  <span>₹{Number(item.lineTotal).toFixed(0)}</span>
                </div>
              ))}
              <div className="border-t border-gray-100 pt-2 mt-1 flex flex-col gap-1">
                <div className="flex justify-between text-sm otaLight">
                  <span>Subtotal</span>
                  <span>₹{order.subtotal.toFixed(0)}</span>
                </div>
                <div className="flex justify-between text-sm otaLight">
                  <span>Shipping</span>
                  <span>₹{order.shippingFee.toFixed(0)}</span>
                </div>
                <div className="flex justify-between text-sm otaLight">
                  <span>Tax</span>
                  <span>₹{order.taxAmount.toFixed(0)}</span>
                </div>
                <div className="flex justify-between text-sm font-bold otaDark pt-1">
                  <span>Total</span>
                  <span>₹{order.totalAmount.toFixed(0)}</span>
                </div>
              </div>
            </div>

            <div className="flex justify-between text-sm p-3.5 rounded-xl bg-gray-50">
              <span className="otaLight">Payment status</span>
              <span className="font-semibold otaDark">
                {order.paymentStatus}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
